export enum LogLevel {
    DEBUG = 'DEBUG',
    INFO = 'INFO',
    ERROR = 'ERROR'
}

export enum LogType {
    inactivityLog = 'inactivity_log',
    log = 'log'
}
